// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import application from './application';
import AvatarController from './avatar_controller';
import AvatarPickerController from './avatar_picker_controller';
import ImagePickerController from './image_picker_controller';
import MapController from './map_controller';
import MapPickerController from './map_picker_controller';

application.register('avatar', AvatarController);
application.register('avatar-picker', AvatarPickerController);
application.register('image-picker', ImagePickerController);
application.register('map', MapController);
application.register('map-picker', MapPickerController);
